module.exports = __webpack_public_path__ + "img/right_question.4d4b0f46.png";